import {
  getDayUses,
  postDayUseCheckIn,
} from '../api/bernabeu';

import {
  dayUseSlice,
  callTypes
} from "../../redux/reducers/dayUseSlice";
import { toast } from 'react-toastify';

const { actions } = dayUseSlice;

const fetchDayUses = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getDayUses().then((response: any) => {
      dispatch(actions.dayUsesFetched());

      resolve(response.data);
    }).catch((error) => {
      console.log('fetchDayUses falhou:');
      console.log({error});

      reject(false);
      dispatch(actions.dayUsesFetched());
    });
  });
}

const fetchDayUse = (id) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getDayUses({ id: id }).then((response: any) => {
      resolve(response.data[0]);

      dispatch(actions.dayUsesFetched());
    }).catch((error) => {
      console.log('fetchCreditPurchases falhou:');
      console.log({error});
      dispatch(actions.dayUsesFetched());

      reject(false);
    });
  });
}

const fetchDayUseCheckIn = (data) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    postDayUseCheckIn(data).then((response: any) => {
      dispatch(actions.dayUseCheckInFetched());
      resolve(response);
    }).catch((error) => {
      console.log('fetchDayUseCheckIn falhou:');
      console.log({error});
      dispatch(actions.dayUseCheckInFetched());

      let message = error.response?.data?.message ?? 'Erro ao realizar check-in!';

      toast.error(message);
      reject(error);
    });
  });
}

export {
  fetchDayUses,
  fetchDayUse,
  fetchDayUseCheckIn,
}